import { axiosInstance } from "axiosConfig";
import { UserDto } from "dto/user-dto";

class AuthService {
  login({
    email,
    password,
  }: {
    email: string;
    password: string;
  }): Promise<UserDto | null> {
    return axiosInstance
      .post("/api/v1/auth/login", { email, password })
      .then((response) => {
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("refreshToken", response.data.refreshToken);
      })
      .then(() => this.getUserInfo())
      .then((userInfo) => {
        localStorage.setItem("user", JSON.stringify(userInfo));

        return userInfo;
      })
      .catch((error) => {
        console.warn(error);

        return Promise.reject(error.response.data);
      });
  }

  logout(): Promise<void> {
    return axiosInstance
      .get("/api/v1/auth/logout")
      .then((response) => {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");
      })
      .catch((error) => {
        console.warn(error);

        return Promise.reject(error.response.data);
      });
  }

  getUserInfo(): Promise<UserDto | null> {
    if (!localStorage.getItem("accessToken")) {
      return Promise.resolve(null);
    }

    return axiosInstance
      .get<UserDto>("/api/v1/auth/me")
      .then((response) => response.data)
      .then((userInfo) => {
        localStorage.setItem("user", JSON.stringify(userInfo));

        return userInfo;
      })
      .catch((error) => {
        console.error("Error fetching user info", error);

        return null;
      });
  }

  getStoredUserInfo(): UserDto | null {
    const json = localStorage.getItem("user");

    if (!json) {
      return null;
    }

    return JSON.parse(json);
  }

  refreshToken(): Promise<{ accessToken: string }> {
    return axiosInstance
      .post("/api/v1/auth/refresh", {
        refreshToken: localStorage.getItem("refreshToken"),
      })
      .then((response) => {
        console.log("Receive new tokens:", response.data);
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        return { accessToken: response.data.accessToken };
      })
      .catch((error) => {
        console.warn(error);

        return Promise.reject(error.response.data);
      });
  }

  isLoginIn(): boolean {
    return !!localStorage.getItem("accessToken");
  }
}

export const authService = new AuthService();
